import { cn } from '@speedlo/ui'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

import { BackgroundThemed } from '../../common/BackgroundThemed'

type TLinkProps = {
  url: Maybe<string>
}

type TProps = TLinkProps & {
  smallLogo: boolean
}

const LogoLink: React.FC<TLinkProps> = ({ url, children }) =>
  url ? <a href={url}>{children}</a> : <Link to="/">{children}</Link>

const LogoContainerStyled = styled.div`
  height: 200px;
  width: 400px;
  flex: 0 0 400px;

  & .shop__header__logo {
    height: 100%;
  }

  & .small-company-logo {
    transform: scale(0.92);
    transform-origin: right bottom;
  }
`

export const ShopLogo: React.FC<TProps> = ({ url, smallLogo }) => (
  <LogoContainerStyled>
    <LogoLink url={url}>
      <BackgroundThemed
        className={cn('shop__header__logo', {
          'small-company-logo': smallLogo,
        })}
        imageName="storeLogo"
        size="cover"
      />
    </LogoLink>
  </LogoContainerStyled>
)
